export default __webpack_public_path__ + "static/media/emptyheart.c412cbae.png";